module.exports.app_id = "Citrus by Polymedia";

module.exports.api_url = "https://citrus-api.polymedia.nl";
module.exports.api_token = "03bVp8M8p9vPI1vc";

if(window.location.href.startsWith("http://localhost:3000/")) {
	module.exports.api_url = "http://localhost:3001";
	module.exports.api_token = "456";
}



// WEBPACK FOOTER //
// ./src/config.js